import React, { ReactElement } from 'react';

export default function IconClose(): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="18"
      viewBox="0 0 17 18"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#ffffff" transform="translate(-1233 -23)">
          <g transform="translate(1233.212 23.992)">
            <path
              d="M-2.612 7.408H18.988V8.968H-2.612z"
              transform="rotate(45 8.188 8.188)"
            ></path>
            <path
              d="M-2.612 7.408H18.988V8.968H-2.612z"
              transform="scale(-1 1) rotate(45 0 -11.58)"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}